import React, {useEffect} from 'react';


/**
 * @param ref {React.ref} Ref to watch for outside clicks
 * @param onOutsideClick {function} Called when click outside of given ref is registered
 */
function useOnOutsideClick(ref, onOutsideClick) {

    useEffect(() => {

        if (!ref.current) {

            return;
        }

        function handleClickOutside(event) {

            if (ref.current && ref.current.contains && !ref.current.contains(event.target)) {
                onOutsideClick();
            }
        }

        document.addEventListener('mousedown', handleClickOutside);

        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [ref]);
}


export default useOnOutsideClick;
